module.exports = __webpack_public_path__ + "static/media/ageelementbrighteningcream.dfe05080.png";